import React from "react";
import { useFormikContext } from "formik";
import { Button, ButtonProps, Theme } from "@literati/public-ui-shared-react";

export const StepFormButton = (props: ButtonProps) => {
  const { isSubmitting, isValid } = useFormikContext();

  const disabled = props.disabled ?? !isValid;

  return (
    <Theme>
      <Button
        type="submit"
        loading={isSubmitting}
        disabled={disabled}
        {...props}
      />
    </Theme>
  );
};

export default StepFormButton;
